import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutSingleComponent } from 'gung-list';
import { Invoice } from 'gung-standard';
import { JeevesInvoiceListConfigService } from 'gung-standard-jeeves';
import { CarLinerInvoiceCardListComponent } from '../components/car-liner-invoice-card-list/car-liner-invoice-card-list.component';

@Injectable({
  providedIn: 'root'
})
export class CarLinerInvoiceListConfigService extends JeevesInvoiceListConfigService {
  getLayouts(): ListLayout<Invoice>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => CarLinerInvoiceCardListComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'Invoice grid'
      }
    ];
  }
}
